import {useEffect} from 'react';

import {useSelector} from 'react-redux';

import {getIsUserLoading, getUser} from '../../modules/selectors/userSelectors';

const STORAGE_KEY = 'gtm_account_login_event_triggered';

const useTrackGtmAccountLogin = () => {
  const loading = useSelector(getIsUserLoading);
  const user = useSelector(getUser);

  useEffect(() => {
    if (loading || user?.roles.includes('student')) {
      return;
    }

    // Ensure we're in the browser
    if (typeof window === 'undefined') {
      return;
    }

    if (!user?.is_authenticated) {
      // Remove login event triggered value so it can be triggered again
      localStorage.removeItem(STORAGE_KEY);
      return;
    }
    const eventTriggered = localStorage.getItem(STORAGE_KEY) === 'true';

    if (eventTriggered) {
      return;
    }
    // Google conversion event tracking
    window.dataLayer?.push({
      event: 'account_login',
    });

    // Prevent double tracking
    localStorage.setItem(STORAGE_KEY, 'true');
  }, [loading, user?.is_authenticated, user?.roles]);

  return null;
};

export default useTrackGtmAccountLogin;
